module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/Fagus/Tokyo_Fagus_GFDL_RCP45_End.png";